import { EScene as E } from "../../common/type.mjs";
const o = {
  [E.REOLINK]: "icon-icon-hint-error",
  [E.CAMOVUE]: "icon-bin-line"
}, r = {
  ERROR: "error",
  SUCCESS: "success",
  UPLOADING: "uploading"
}, i = 1024 * 1024;
export {
  o as CLOSE_ICON_NAME,
  r as FILE_STATUS,
  i as ONE_MEGABYTE
};
//# sourceMappingURL=const.mjs.map
